module.exports = __webpack_public_path__ + "static/media/DSCF4753.7350fcac.jpg";